import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _MessageBox2 from "element-ui/lib/theme-chalk/message-box.css";
import "element-ui/lib/theme-chalk/base.css";
import _MessageBox from "element-ui/lib/message-box";
import _defineProperty from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.to-string.js";
import axios from 'axios';
axios.defaults.withCredentials = true;
var CancelToken = axios.CancelToken;
var HttpError = {
  400: '请求错误',
  403: '拒绝访问',
  404: '请求地址错误',
  408: '请求超时',
  500: '服务器开个小差，请稍后再试',
  501: '服务器开个小差，请稍后再试',
  502: '服务器开个小差，请稍后再试',
  503: '服务器开个小差，请稍后再试',
  504: '服务器开个小差，请稍后再试',
  505: 'HTTP版本不受支持'
};
axios.interceptors.request.use(function (config) {
  config.headers.common = {
    'Content-Type': 'application/json;charset=UTF-8',
    'X-ER-System-Info': 'default',
    'Accept-Language': 'zh-CN'
  };
  config.crossDomain = true;
  config.timeout = 150000;
  return config;
}, function (error) {
  return Promise.reject(error);
}); // 拦截响应response，并做一些错误处理

axios.interceptors.response.use(function (res) {
  try {// TODO: set response pre-judge-handler
  } catch (e) {// 错误
  }

  return res;
}, function (err) {
  return Promise.reject(err);
});
/**
 * @func axios的二次封装
 * @param p method-请求方法，url-接口地址，data-请求参数
 */

var request = function request(url, data, meth, _this) {
  var token, tokenName;
  var method = meth || 'GET';
  var paramsKey = method.toUpperCase() === 'GET' ? 'params' : 'data';

  if (data && data.tokenParams) {
    tokenName = 'token';
    token = data.tokenParams;
    delete data.tokenParams;
  }

  var headersParams = {};

  if (data && data.headersParams) {
    headersParams = data.headersParams;
    delete data.headersParams;
  }

  return new Promise(function (resolve, reject) {
    var _axios;

    axios((_axios = {
      url: url,
      method: method
    }, _defineProperty(_axios, paramsKey, data || {}), _defineProperty(_axios, "headers", _objectSpread(_defineProperty({}, tokenName, token), headersParams)), _defineProperty(_axios, "cancelToken", new CancelToken(function executor(c) {
      if (_this) {
        _this.cancelRequestFn = c;
      }
    })), _axios)).then(function (res) {
      if (res.data && res.data.code === '9999' || res.data && res.data.code === '-1') {
        _MessageBox.confirm('', '服务端异常，请联系管理员', {
          customClass: 'customer-confirm'
        });

        reject(res);
      }

      resolve(res.data);
    }).catch(function (e) {
      console.log('【Api请求错误了】', url);

      if (e.toString().includes('Request failed') || e.toString().includes('timeout')) {
        _Message.close();

        _Message.warning('当前网络不可用，请检查网络设置');
      } else if (e.response && e.response.status && e.response.status === '500') {
        var response = JSON.parse(JSON.stringify(e.response));
        var message = response.data && response.data.message;
        if (message) _Message.error(message);
      } else {
        if (e.response && e.response.status) {
          _Message.error(HttpError[e.response.status]);
        }
      }

      reject(e);
    });
  });
};

export default request;